export const defaultState = () => {
  return {
    articlepages: {
      groups: [],
      fetched: false
    },
    subpages: {
      groups: [],
      fetched: false
    },
    homepages: {
      groups: [],
      fetched: false
    },
    productpages: {
      groups: [],
      fetched: false
    },
    collectionpages: {
      groups: [],
      fetched: false
    }
  };
};

const state = defaultState();

export default state;
